import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  isAndroid(): boolean {
    return /android/i.test(navigator.userAgent);
  }

  isIOS(): boolean {
    return /iphone|ipad|ipod/i.test(navigator.userAgent);
  }
}
